import zappy from "@zappy-ride/library.react.components";
import { ProjectVehicleSelectionTabs } from "./ProjectVehicleSelectionTabs";

export * from "./ProjectVehicleSelectionTabs";

zappy.FactoryInstance.registerComponent(ProjectVehicleSelectionTabs);
